<template>
    <div class="specialInfo">
        <div
            v-if="medicalSpecialInfo"
            class="medIcon"
            :class="{ 'greyed-out': !statusIsPresent }"
            :title="$t('child_checkin_label_specialInformation')"
        >
            <i class="icon-info"></i>
        </div>
        <div
            v-if="drugInfo"
            class="medIcon"
            :class="{ 'greyed-out': !statusIsPresent }"
            :title="$t('child_checkin_label_medication')"
        >
            <i class="icon-medkit"></i>
        </div>
        <div
            v-if="nutritionInfo"
            class="medIcon"
            :class="{ 'greyed-out': !statusIsPresent }"
            :title="$t('child_checkin_label_specialNutrition')"
        >
            <i class="icon-cutlery"></i>
        </div>
        <div
            v-if="medicalInfo"
            class="medIcon"
            :class="{ 'greyed-out': !statusIsPresent }"
            :title="$t('child_checkin_label_medicalInformations')"
        >
            <i class="icon-plus-square"></i>
        </div>
    </div>
</template>

<script>
export default {
    name: 'AppTabletViewChildMedicalInfo',
    props: {
        medicalSpecialInfo: {
            type: Boolean,
            required: false,
            default: false,
        },
        drugInfo: {
            type: Boolean,
            required: false,
            default: false,
        },
        nutritionInfo: {
            type: Boolean,
            required: false,
            default: false,
        },
        medicalInfo: {
            type: Boolean,
            required: false,
            default: false,
        },
        statusIsPresent: {
            type: Boolean,
            required: false,
            default: true,
        },
    },
}
</script>

<style scoped lang="scss" rel="stylesheet/scss">
    .greyed-out {
        -webkit-filter: grayscale(100%);
        filter: grayscale(100%);
    }

    .specialInfo {
        display: flex;
        flex-direction: column-reverse;
        color: red;
        position: absolute;
        width: 19px;
        bottom: 70px;
        left: 0;
    }

    .medIcon {
        float: left;
    }
</style>
